import { addYears, parseISO } from "date-fns";

import { AccountOption } from "../../../../components/AccountMultiSelect";
import { SavingsGoalResponse } from "../../../../services";
import { goalYearOf, localToday } from "../../../../utils";
import { modeOptionOf } from "./constants";
import { SavingsGoalFormValues } from "./types";

const nextTargetDateOf = (targetDate: string) => {
  const today = localToday();
  const previous = parseISO(targetDate);
  let years = 1;
  while (addYears(previous, years) < today) {
    years += 1;
  }
  return addYears(previous, years);
};

// Digit lookarounds rather than \b, so "House_2027" rolls but "Fund 120277" does not.
const standaloneYearPattern = (year: string) =>
  new RegExp(`(?<!\\d)${year}(?!\\d)`, "g");

export const rollForwardValuesOf = (
  goal: SavingsGoalResponse,
  accounts: AccountOption[],
): SavingsGoalFormValues => {
  const nextDate = nextTargetDateOf(goal.targetDate);
  const availableIds = new Set(accounts.map((account) => account.id));

  return {
    name: goal.name.replace(
      standaloneYearPattern(goalYearOf(goal)),
      String(nextDate.getFullYear()),
    ),
    targetAmount: goal.targetAmount,
    targetDate: nextDate,
    mode: modeOptionOf(goal.mode),
    accountIds: goal.accountIds.filter((id) => availableIds.has(id)),
  };
};
